<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <b-button variant="primary" class="btn btn-primary float-right mb-1" 
                    v-on:click="addSalary()" v-if="loginState.isAdministrator" :disabled="!canAddSalary()">
                <i class="fa fa-plus"/>&nbsp;Ny lön
                </b-button>
            </div>
        </div>


        <b-card v-for="(salary, index) in v.$each.$iter" v-bind:key="index">
            <div slot="header">
                <span v-if="index != 0 || salaries.length == 1 || !loginState.isAdministrator || $moment(salary.fromDate.$model).startOf('month') < $moment().startOf('month')">{{formatDate(salary.fromDate.$model)}} - {{formatDate(salary.toDate.$model)}}</span>
                <span v-else>
                    <date-picker v-model.trim="salary.fromDate.$model" 
                        type="month" 
                        lang="en" 
                        :disabled="!loginState.isAdministrator"
                        style="width:100px"
                        format="YYYY-MM"
                        v-on:change="fromDateChanged(salary.$model)"
                        :not-before="notBeforeDate(salary.$model)"></date-picker> - {{anställningsAvslutName}}
                </span>

                <div class="card-header-actions">
                    <i class="fa fa-trash-o fa-lg" style="cursor: pointer;" v-on:click="removeSalary()" 
                        v-if="loginState.isAdministrator && index == 0 && salaries.length > 1 && $moment(salary.fromDate.$model).startOf('month') > $moment().startOf('month')"></i>
                </div>
            </div>            
            <div class="form-row">
                <div class="form-group col-5 col-sm-3 col-md-2 col-lg-1">
                    <label for="baseSalary" class="mr-1">Grundlön</label>
                    <b-form-input type="number"
                        id="baseSalary"
                        maxlength="6"
                        :disabled="!loginState.isAdministrator || index != 0 || (salary.id.$model != 0 && $moment(salary.fromDate.$model).startOf('month') < $moment().startOf('month'))"
                        step="1" 
                        v-model.number="salary.basicSalary.$model"
                        :class="{ 'is-invalid': salary.basicSalary.$anyError}"></b-form-input>
                    <b-form-invalid-feedback>
                        Obligatoriskt fält >= 0 
                    </b-form-invalid-feedback> 
                </div>

                <div class="form-group col-4 col-sm-2 col-md-2 col-lg-2">
                    <label for="taxTable">Skattetabell</label>
                    <b-form-input type="number"
                        id="taxTable"
                        maxlength="2"
                        style="width:100px"
                        :disabled="!loginState.isAdministrator || index != 0 || (salary.id.$model != 0 && $moment(salary.fromDate.$model).startOf('month') < $moment().startOf('month'))"
                        step="1"
                        v-model.number="salary.taxTable.$model"
                        :class="{ 'is-invalid': salary.taxTable.$anyError}"></b-form-input>
                    <b-form-invalid-feedback>
                        Obligatoriskt fält mellan 29 och 40
                    </b-form-invalid-feedback> 
                </div>
            </div>
            <div class="form-group">
                <b-form-checkbox :disabled="!loginState.isAdministrator  || index != 0 || (salary.id.$model != 0 && $moment(salary.fromDate.$model).startOf('month') < $moment().startOf('month'))"
                    @change="variableSalaryChecked($event, salary)"
                    v-model.number="salary.haveVariableSalaryByOccupancy.$model">&nbsp;Rörlig lön
                </b-form-checkbox>
            </div>   
        
            <div class="form-group" v-if="salary.$model.haveVariableSalaryByOccupancy">
                <label class="form-label">Rörlig lön</label>
                <b-form-input class="form-control col-md-2" 
                    type="number"
                    :disabled="!loginState.isAdministrator || index != 0 || (salary.id.$model != 0 && $moment(salary.fromDate.$model).startOf('month') < $moment().startOf('month'))"
                    maxlength="6" 
                    v-model.number="salary.variableSalary.$model"
                    :class="{ 'is-invalid': salary.variableSalary.$anyError}">
                </b-form-input>
                <b-form-invalid-feedback>
                    Obligatoriskt fält >= 0 
                </b-form-invalid-feedback> 
            </div>

            <div class="form-group" v-if="salary.$model.haveVariableSalaryByOccupancy">
                <label class="form-label">Brytgräns</label>
                <b-form-input class="form-control col-md-1" 
                    :disabled="!loginState.isAdministrator || index != 0 || (salary.id.$model != 0 && $moment(salary.fromDate.$model).startOf('month') < $moment().startOf('month'))"
                    type="number" 
                    maxlength="3" step="0.1" 
                    v-model.number="salary.variableSalaryCutOff.$model"
                    :class="{ 'is-invalid': salary.variableSalaryCutOff.$anyError}"/>
                <b-form-invalid-feedback>
                    Obligatoriskt fält mellan 0 och 1
                </b-form-invalid-feedback> 
            </div>             

        </b-card>



    </div>
</template>
<script>
import { globalStore } from "../../../shared/helpers";
import DatePicker from 'vue2-datepicker'


export default {
    components: {
        DatePicker,
    },      
    computed: {
        loginState : function() {
            return globalStore.loginState;
        },
    },        
    props: {
        salaries: null,
        v: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            anställningsStartName: "Anställningsstart",
            anställningsAvslutName: "Anställningsavslut",
        }
    },
    methods: {
       canAddSalary() {
            if(this.v.$invalid) return false;

            return this.salaries.length == 0 || !this.isAnställningsAvslut(this.salaries[0].date);
        },
        isAnställningsAvslut(date) {
            return this.$moment(date).isAfter("9000-01-01");
        },
        formatDate(date) {
            var dateMoment = this.$moment(String(date));

            if(dateMoment.isBefore("1900-01-01")) return this.anställningsStartName;
            if(dateMoment.isAfter("9000-01-01")) return this.anställningsAvslutName;

            return dateMoment.format('YYYY-MM');
        },
        fromDateChanged(salary) {
            console.log(salary);
            var salaryFromDateMoment = this.$moment(salary.fromDate);
            var prevousSalary = this.salaries[this.salaries.indexOf(salary) + 1];
            
            prevousSalary.toDate = salaryFromDateMoment.subtract(1, 'months')
                .endOf('month').subtract(12, 'hours').toDate();

            salary.fromDate = salaryFromDateMoment.add(1, 'days').toDate();
        },  
        notBeforeDate(salary) {
            
            return this.$moment().startOf('month');
        },
        addSalary() {
            var fromDate = this.$moment("1753-01-01").toDate();
            var toDate = this.$moment("9999-12-01").toDate();

            var lastSalary = this.salaries[0];

            if(lastSalary) {
                if(lastSalary.fromDate > this.$moment()) {
                    lastSalary.toDate = this.$moment(lastSalary.fromDate).endOf('month').toDate()
                }
                else {
                    lastSalary.toDate = this.$moment().add(-1, 'month').endOf('month').toDate();
                }
                fromDate = this.$moment(lastSalary.toDate).add(1, 'months').startOf('month').add(1, 'days').toDate();
            }
        
            var newSalary = {
                id: 0,
                basicSalary : null,
                taxTable : null,
                fromDate,
                toDate,
                haveVariableSalaryByOccupancy: false,
                variableSalary: null,
                variableSalaryCutOff: null
            };

            this.salaries.unshift(newSalary);
        },    
        removeSalary() {
            this.salaries.splice(0, 1);

            if(!this.salaries[0]) return;
            this.salaries[0].toDate = this.$moment("9999-12-31").toDate();
        },
        variableSalaryChecked(checked, salary) {
            if(checked) return;
            salary.$model.variableSalary = null;
            salary.$model.variableSalaryCutOff = null;
        }         
    },
    mounted() {
        
    }      
    
}
</script>

